import { isValidLoginEmail } from '../loginIdentifier';
import {
  getOtpResendStorageKey,
  getVerifyPathForOtp,
  markOtpResendCooldown,
  OTP_RESEND_COOLDOWN_MS,
} from '../otpCooldown';

export function getRegistrationValidity(formData) {
  const hasValidPhone = formData.phone.length === 10;
  // Same rule as login: local@domain + TLD of 2+ letters (not just "@").
  const hasValidEmail = isValidLoginEmail(formData.email);
  return { hasValidPhone, hasValidEmail };
}

export function validateRegistrationForm(formData) {
  const { hasValidPhone, hasValidEmail } = getRegistrationValidity(formData);

  if (!hasValidPhone && !hasValidEmail) {
    return 'Please enter a valid 10-digit mobile number or email address.';
  }

  if (!formData.firstName.trim()) {
    return 'First name is required.';
  }

  if (!formData.lastName.trim()) {
    return 'Last name is required.';
  }

  if (formData.pincode && formData.pincode.length !== 6) {
    return 'Please enter a valid 6-digit pincode or leave it empty.';
  }

  return null;
}

export function buildRegisterPayload(formData, channel) {
  const { hasValidPhone, hasValidEmail } = getRegistrationValidity(formData);

  const payload = {
    firstName: formData.firstName.trim(),
    lastName: formData.lastName.trim(),
    ...(formData.pincode && formData.pincode.length === 6 && {
      pincode: parseInt(formData.pincode, 10),
    }),
  };

  if (channel === 'email') {
    payload.email = formData.email.trim();
    payload.channel = 'email';
  } else {
    payload.phone = formData.phone;
    payload.channel = channel;
    if (hasValidEmail) {
      payload.email = formData.email.trim();
    }
  }

  return payload;
}

export function getVerifyPath(channel, formData) {
  const type = channel === 'email' ? 'email' : channel === 'whatsapp' ? 'whatsapp' : 'phone';
  const identifier = channel === 'email' ? formData.email.trim() : formData.phone;
  return getVerifyPathForOtp(type, identifier);
}

/** After successful /users/register — mark register cooldown and open verify. */
export function navigateAfterRegistration(navigate, { channel, formData, responseData = {} }) {
  const otpType = channel === 'email' ? 'email' : channel === 'whatsapp' ? 'whatsapp' : 'phone';
  const otpId = channel === 'email' ? formData.email.trim() : formData.phone;
  const retryAfterSeconds = Number(responseData.retryAfterSeconds);
  const storageKey = getOtpResendStorageKey({
    purpose: 'register',
    type: otpType,
    identifier: otpId,
  });

  if (responseData.otpStillActive && Number.isFinite(retryAfterSeconds) && retryAfterSeconds > 0) {
    markOtpResendCooldown(storageKey, retryAfterSeconds * 1000);
  } else {
    const cooldownSec = Number(responseData.cooldownSeconds);
    markOtpResendCooldown(
      storageKey,
      Number.isFinite(cooldownSec) && cooldownSec > 0
        ? cooldownSec * 1000
        : OTP_RESEND_COOLDOWN_MS
    );
  }

  navigate(getVerifyPath(channel, formData), {
    state: {
      otpAlreadySent: true,
      authFlow: 'register',
      otpStillActive: Boolean(responseData.otpStillActive),
      retryAfterSeconds:
        responseData.otpStillActive && retryAfterSeconds > 0 ? retryAfterSeconds : undefined,
    },
  });
}
